import React, { useEffect } from 'react';
import SimpleSearch from '../teal-react/components/organisms/SimpleSearch';
import { useDebounce } from '../teal-react/hooks/useDebounce';
import { useQcSearch } from '../graphql/queries';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import { useNavigate } from 'react-router';
import Utils from '../teal-react/utils';
import Typo from '../teal-react/components/atoms/Typo';
// import { Api, Utils } from '@jesseteal/teal-react'

const QcSearch = () => {
  const [searchTerm, setSearchTerm] = React.useState<string>('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [search, { data }] = useQcSearch(`%${debouncedSearchTerm}%`);
  const navigate = useNavigate();

  useEffect(() => {
    if (debouncedSearchTerm.trim() !== '') {
      search();
    }
  }, [debouncedSearchTerm]);
  return (
    <>
      <SimpleSearch onFilter={setSearchTerm} placeholder="Search By QC Code" />
      <hr />
      {data && debouncedSearchTerm ? (
        <>
          <SimpleTable
            noCard
            fullWidth={true}
            data={data?.qc}
            row_action={(r: any) => {
              navigate(`/products/${r.product?.id}/${r.id}`);
            }}
            columns={[
              {
                header: 'First 10 Search Results',
                cell: (r: any) => {
                  return (
                    <>
                      <div className="row">
                        <div className="col">{Typo.header(r.qc_code)}</div>
                        <div className="col">{Typo.subheader(r.status)}</div>
                      </div>
                      <div className="row">
                        <div className="col">
                          {Utils.date.formatDate(r.date)}
                        </div>
                        <div className="col">Product: {r.product.code}</div>
                      </div>
                    </>
                  );
                },
              },
            ]}
          />
        </>
      ) : null}
    </>
  );
};

export default QcSearch;
